import React from "react";
import { useFormatMsg } from "src/hooks/useFormatMsg";
import useLeftAndRightLists from "../../listHooks/useLeftAndRightLists";
import X2yForm from "../../X2yForm";
import { useSubmitNotificationSubscriptions } from "./hooks/useSubmitSubscriptions";
import { useSubscribedNotificationTemplates } from "./hooks/useSubsribedNotificationTemplates";
import { getNewValues, mapOptionToId } from "./utils";

type Props = {
  placeholder: string;
  disableSearch?: boolean;
  onSaveCallback(): void;
};

const X2yNotifications = ({
  placeholder,
  disableSearch = false,
  onSaveCallback,
}: Props) => {
  const formatMsg = useFormatMsg();

  const { isSubmitting, submitSubscriptions } =
    useSubmitNotificationSubscriptions(onSaveCallback);
  const { subscribed, unsubscribed, isFetching, optionsById } =
    useSubscribedNotificationTemplates();

  const { leftList, rightList, moveLeft, moveRight } = useLeftAndRightLists({
    headerLeft: formatMsg("x2y.table_data.unselected"),
    headerRight: formatMsg("x2y.table_data.selected"),
    allOptionsById: optionsById,
    initialIdsLeft: unsubscribed,
    initialIdsRight: subscribed,
    searchEnabled: !disableSearch,
  });

  const onSave = () => {
    const leftIds = leftList.options.map(mapOptionToId);
    const rightIds = rightList.options.map(mapOptionToId);

    const toUnsubscribe = getNewValues(leftIds, unsubscribed);
    const toSubscribe = getNewValues(rightIds, subscribed);

    submitSubscriptions(toSubscribe, toUnsubscribe);
  };

  return (
    <X2yForm
      leftList={leftList}
      rightList={rightList}
      moveLeft={moveLeft}
      moveRight={moveRight}
      onSave={onSave}
      isFetching={isFetching}
      isSubmitting={isSubmitting}
      placeholder={placeholder}
    />
  );
};

export default X2yNotifications;
